import { jsx as _jsx } from "react/jsx-runtime";
import { InsulinProtocolModalForm, Modal } from "@madmedical/ui";
import { ApiFormWrapper } from "@madmedical/form";
import { usePatientId } from "@madmedical/user";
import { useEffect } from "react";
import { useUpdateInsulinProtocolMutation } from "../api";
const UpdateInsulinProtocolModalForm = ({ open, onClose, protocol, refetchProtocol, }) => {
    const { id, instructions } = protocol;
    const { patientId } = usePatientId();
    const [updateProtocol, { isSuccess }] = useUpdateInsulinProtocolMutation();
    useEffect(() => {
        if (isSuccess) {
            refetchProtocol();
        }
    }, [isSuccess, refetchProtocol]);
    return (_jsx(Modal, Object.assign({ open: open, size: "sm", onClose: onClose }, { children: _jsx(ApiFormWrapper, Object.assign({ defaultValues: {
                patientId,
                id,
                instructions,
            }, mutation: updateProtocol, resetOnSuccess: true }, { children: ({ submitForm, isSuccess }) => (_jsx(InsulinProtocolModalForm, { isSuccess: isSuccess, onClose: onClose, onSubmitPress: submitForm })) })) })));
};
export default UpdateInsulinProtocolModalForm;
